<template>
    <ValidationProvider
        :mode="validationMode"
        :name="label || name || 'unknown'"
        :rules="rules"
        :vid="id"
        v-slot="{ validated, valid, errors }"
        slim
    >
        <rkm-form-group
            v-if="label"
            :invalid-feedback="errors[0]"
            :label-for="id"
            :description="description"
            :label="label + (validations && validations.required ? ' *' : '')"
            :state="rules ? (disabled ? null : (validated ? valid : null)) : null"
        >
            <VueEditor
                :editor-toolbar="editorToolbar"
                :disabled="disabled"
                :placeholder="placeholder"
                :value="value"
                @input="$emit('input', $event)"
            />

            <div
                v-if="rules && rules.max"
                :style="caracteresRestantesStyle"
            >
                Caracteres restantes: {{ caracteresRestantes }}
            </div>
        </rkm-form-group>
    </ValidationProvider>
</template>

<script>
import { VueEditor } from "vue2-editor"
import { ValidationProvider } from 'vee-validate';

export default {
    components: { VueEditor, ValidationProvider },
    computed: {
        id() {

            // TODO: Centralizar e a tratar melhor a string, removendo caracteres especiais, acentos, etc.
            const id = (this.label || this.name || 'unknown')
                .toLowerCase()
                .replace(/[()\\/\-<>]/gi, '')
                .replace(/[\s]/gi, '-')

            return this.uniqueId(id)
        },
        rules() {

            return this.disabled ? null : this.validations
        },
        caracteresRestantes() {

            const value = (typeof this.value === 'string') ? this.value.length : 0
            const charactersLeft = this.rules.max - value

            return charactersLeft > 0 ? charactersLeft : 0
        },
        caracteresRestantesStyle() {

            return {
                fontSize: '13px',
                color: 'gray',
            }
        }
    },
    data() {
        return {
            editorToolbar: [
                [
                    { header: [false, 1, 2, 3, 4, 5, 6] }
                ],
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [
                    { list: "ordered" },
                    { list: "bullet" },
                    { list: "check" }
                ],
                [
                    { color: [] },
                    { background: [] }
                ],
            ],
        }
    },
    props: {
        disabled: { type: Boolean },
        label: { type: String },
        placeholder: { type: String },
        value: { type: [Number, String], default: '' },
        description: { type: String },
        validationMode: { type: String, default: 'aggressive' },
        name: { type: String },
        required: { type: Boolean, default: false },
        validations: { type: Object, default: null },
    }
}
</script>